import { defineStore } from 'pinia'
import { reactive, toRefs } from '@vue/composition-api'
import { practiceService } from '@/services/practice.service'


export const usePracticeStore = defineStore('practice-store', () => {
    const state = reactive({
        availableSurveyVersions: {},
        lastUpdated: null,
    })

    const getAvailableSurveyVersions = async () => {
        if (state.lastUpdated && (new Date() - state.lastUpdated) < 5 * 60 * 1000) {
            return
        }
        const versions = await practiceService.getAvailableSurveyVersions()
        state.availableSurveyVersions = versions
        state.lastUpdated = new Date()
    }

    return {
        ...toRefs(state),
        getAvailableSurveyVersions
    }
})